import { Component, Input } from '@angular/core';

import { GlobalHelper } from 'src/app/helper/global.helper';
import { PatientRequestService } from 'src/app/modules/patient/request-and-result/services';

@Component({
  selector: 'app-request-print-all-btn',
  templateUrl: './request-print-all-btn.component.html',
  styleUrls: ['./request-print-all-btn.component.css'],
  providers: [PatientRequestService]
})
export class RequestPrintAllBtnComponent {

  @Input('printContent') printContent;
  @Input('requestPrint') requestPrint;

  printDatas: any = {};
  showResultPrintAll = false;

  constructor(private globalHelper: GlobalHelper, private modelService: PatientRequestService) { }

  printAllReq(reqDatas) {
    reqDatas.allPrintLoading = true;
    const self = this, curOrgId = this.globalHelper.getCurData('curOrgId'),
      ajHospitalOrgId = this.globalHelper.getConstantsValue('app').ajHospitalOrgId,
      paramsOptions = this.globalHelper.convertObjectToParams({ encounter_id: reqDatas.encounter_id });
    this.modelService.getPrintPatReqsAll({ params: paramsOptions }).subscribe((results: any) => {
      if (results) {
        self.printDatas = {
          pat_request : results.patient_request,
          print_setting: results.patient_result_print_setting,
          patient_data: reqDatas
        };
        self.showResultPrintAll = true;
        const printSetting = results.patient_result_print_setting;
        let appendStyle = `margin-bottom: ${printSetting.margin_bottom}mm;`;
        appendStyle += `margin-top: ${printSetting.margin_top}mm;`;
        appendStyle += `margin-left: ${printSetting.margin_left}mm;`;
        appendStyle += `margin-right: ${printSetting.margin_right}mm`;
        setTimeout(() => {
          (<any>$('#result-all-print')).print({
            globalStyles: true,
            mediaPrint: false,
            stylesheet: '/assets/css/prescription_print.css',
            noPrintSelector: '.no-print',
            iframe: false,
            append: `<style>@page{${curOrgId !== ajHospitalOrgId ? appendStyle : ''}}</style>`,
            prepend: '',
            title: 'All Result Print'
          });
          reqDatas.allPrintLoading = self.showResultPrintAll = false;
        }, 600);
      }
    }, error => {
      reqDatas.allPrintLoading = false;
    });
  }
}
